import { render, staticRenderFns } from "./DayPickerPanel.vue?vue&type=template&id=504a6d06&scoped=true&"
import script from "./DayPickerPanel.vue?vue&type=script&lang=js&"
export * from "./DayPickerPanel.vue?vue&type=script&lang=js&"
import style0 from "./DayPickerPanel.vue?vue&type=style&index=0&id=504a6d06&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504a6d06",
  null
  
)

export default component.exports